export default {"src":"/_next/static/media/theta.12637892.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};